import { Typography } from '@mui/material'
import { FC } from 'react'
import { StatContainer, Description, TextContainer } from './styled'

const Stat: FC<IStatComponent> = ({ stat }) => {
  return (
    <StatContainer>
      <TextContainer>
        <Typography
          component="span"
          variant="h4"
          sx={(theme) => ({ whiteSpace: 'nowrap', color: theme.palette.surface['100'] })}
        >
          {stat.value} {stat.valueSymbol}
        </Typography>
        <Description>{stat.description}</Description>
      </TextContainer>
    </StatContainer>
  )
}

export default Stat
